export interface ValidationErrorDetail {
  code?: string | null;
  context?: string | null;
  description?: string | null;
  element?: string | null;
  isTranslated?: boolean;
  message?: string;
  param?: string | null;
  tokens?: Record<string, string> | null;
}

interface ValidationErrorOpts {
  code?: string | null;
  details?: ValidationErrorDetail | ValidationErrorDetail[] | null;
  element?: string | null;
  context?: string | null;
  description?: string | null;
  tokens?: Record<string, string> | null;
  isTranslated?: boolean;
}

export default class ValidationError extends Error {
  isFriendly: boolean;
  code: string | null;
  details: ValidationErrorDetail | ValidationErrorDetail[] | null;
  element: string | null;
  context: string | null;
  description: string | null;
  tokens: Record<string, string> | null;
  isTranslated: boolean;

  constructor(message: string, opts: ValidationErrorOpts = {}) {
    super(message);
    const {
      code = null,
      details = null,
      element = null,
      context = null,
      description = null,
      tokens = null,
      isTranslated = false,
    } = opts;

    this.isFriendly = true;
    this.code = code;
    this.details = details;
    this.element = element;
    this.context = context;
    this.description = description;
    this.tokens = tokens;
    this.isTranslated = isTranslated;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    }
  }
}
